const BILLION = 1000000;

const TEN_THOUSANDS = 10000;

const THOUSAND = 1000;

const FRACTION_DIGITS = 1;

export const roundTotalSum = (value: number): string | number => {
  if (!value) return "";

  if (value >= BILLION) {
    return `${(value / BILLION).toFixed(FRACTION_DIGITS)}M`;
  }

  if (value >= TEN_THOUSANDS) {
    return `${(value / THOUSAND).toFixed(FRACTION_DIGITS)}K`;
  }

  return value;
};
